import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxury%20Macau%20integrated%20resort%20exterior%20with%20golden%20warm%20lighting%20at%20sunset%2C%20grand%20palace%20architecture%20with%20fountain%20lake%20reflection%2C%20elegant%20luxurious%20atmosphere%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20stylized%20artistic%20rendering%20with%20soft%20focus%2C%20warm%20cream%20and%20gold%20tones%2C%20cinematic%20wide%20shot%2C%20asian%20luxury%20aesthetic&width=1800&height=900&seq=hero-wynn-palace-01&orientation=landscape"
        alt="永利皇宫澳门顶级综合度假胜地外观全景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <i className="ri-vip-crown-line text-primary-300 text-sm"></i>
            <span className="text-white/90 text-xs md:text-sm font-medium tracking-wide">
              澳门顶级综合度假胜地
            </span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
            永利皇宫
            <span className="block text-2xl md:text-3xl lg:text-4xl font-medium text-white/90 mt-2">
              官方体验指南
            </span>
          </h1>

          <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
            汇聚五星级酒店、米其林星级餐饮、世界级娱乐表演与顶级购物体验，
            为您呈现澳门最尊贵的度假生活方式
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/hotel"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer"
            >
              探索酒店套房
            </Link>
            <Link
              to="/category/travel"
              className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/25 text-white font-medium text-sm whitespace-nowrap hover:bg-white/25 transition-all duration-300 cursor-pointer"
            >
              查看旅游攻略
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-2 text-white/60 text-xs">
          <i className="ri-mouse-line"></i>
          <span>向下滚动探索更多</span>
        </div>
      </div>
    </section>
  );
}